<template>
	<div class="home">
		<AucHeader></AucHeader>
		<AucBanner></AucBanner>
		<div class="itemlistbox"><router-view/></div>
		<AucFooter></AucFooter>
	</div>
</template>

<script>
	import AucHeader from '../components/Header.vue'
	import AucBanner from "../components/Banner.vue"
	import AucFooter from '../components/Footer.vue'

	export default {
		name: "Home",
		components: {
			AucHeader,
			AucBanner,
			AucFooter
		}
	};
</script>
